<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
               :custom-filter="customFilter"

      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar dark color="blue darken-3" class="mb-1">
          <v-text-field v-model="search" clearable flat solo-inverted hide-details label="Search"></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="sortDesc" mandatory>
              <v-btn large depressed color="blue" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn large depressed color="blue" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col v-for="item in props.items" :key="item.title" cols="12" sm="6" md="4" lg="3">
            <v-card style="overflow-y: auto; height:80px" v-on:click="navigateProductDetail(item)">
              <table class="pa-1">
                <tr>
                  <td>
                    <img :src="item.icon" width="60" class="center" />
                  </td>
                  <td class="pl-2" style="font-size:14px;">{{ item.id }}<br />{{ item.title }}</td>
                </tr>
              </table>

              <!-- <v-card-title class="subheading font-weight-bold">
                
               
              </v-card-title>-->
              <!-- <v-card-subtitle></v-card-subtitle> -->
              <!-- <v-divider></v-divider> -->

              <!-- <v-list dense>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content :class="{ 'blue--text': sortBy === key }">{{ key }}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'blue--text': sortBy === key }"
                  >{{ item[key.toLowerCase()] }}</v-list-item-content>
                </v-list-item>
              </v-list>-->
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="ma-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
          <v-btn fab dark color="blue darken-3" class="mr-1" @click="formerPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  data() {
    return {
      //ここに変数や定数を定義
      itemsPerPageArray: [32, 64, 128],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 32,
      sortBy: "name",
      keys: ["Id", "Title", "Icon"],
      items: []
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    navigateProductDetail(appli) {
      //現在の表示数・ページ番号を保存
      this.$store.commit("updateAppLiPage", this.page);
      this.$store.commit("updateAppLiPerPage", this.itemsPerPage);

      this.$router.push({
        name: "appliDetails",
        params: { id: appli.id }
      });
    },


    customFilter(items, search) {
        //search = search.toString().toLowerCase()
        // console.log(items)

        if(search == null){
          search = ""
        }

        var tmp = []

        items.forEach(element => {

          if ( element["title"].indexOf(search) != -1) {
            tmp.push(element)
          }

          else if ( element["sub_title"].indexOf(search) != -1) {
            tmp.push(element)
          }
          else if ( element["id"].indexOf(search) != -1) {
            tmp.push(element)
          }
        });

        return tmp

        // return items.filter(row => this.filter(row["season"], search));
    }


  },

  created: function() {
    //すでにデータを取得していれば
    if (this.$store.getters.appliData.length > 0) {
      this.items = this.$store.getters.appliData;
      this.page = this.$store.getters.appliPage;
      this.itemsPerPage = this.$store.getters.appliitemsPerPage;
    } else {
      //api先からデータ取得
      axios
        .get(
          process.env.VUE_APP_LIST
        )
        .then(response => {
          console.log(response);
          // v-data-tableを使うときは配列に格納する
          // const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            const item = {
              id: value.app_id,
              category: value.category,
              icon: value.icon,
              title: value.title,
              sub_title: value.sub_title,
              memo: value.memo || "",
              source: value.source || "",
              img_count: value.img_count,
              imageData1: "",
              imageData2: ""
            };
            this.items.push(item);
          });

          this.$store.commit("updateAppLiData", this.items);
          // this.list = items;
        });
    }
  }
};
</script>

<style>
</style>